var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"base-card"}},[_c('span',[_vm._v(_vm._s(_vm.titulo))]),_c('span',[_vm._v(_vm._s(_vm.valor))])])
}
var staticRenderFns = []

export { render, staticRenderFns }